import './expandable.scss'

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.expandable-wrapper').forEach(wrapper => {
        const container = wrapper.querySelector<HTMLElement>('.expandable-container');
        const shortText = wrapper.querySelector<HTMLElement>('.expandable-short');
        const icon = wrapper.querySelector<HTMLElement>('.expand-icon');
        if(!container || !shortText || !icon) {
            return;
        }
        // Initially, only short is visible — measure it
        container.style.maxHeight = shortText.scrollHeight + 'px';

        icon.addEventListener('click', () => {
            const isExpanding = !wrapper.classList.contains('expanded');

            // Measure the height BEFORE changing DOM
            const startHeight = container.scrollHeight;

            // Toggle .expanded to swap short/full content visibility
            wrapper.classList.toggle('expanded');

            // Wait a tick for the DOM to update
            requestAnimationFrame(() => {
                const endHeight = container.scrollHeight;

                // Reset to start height to trigger animation
                container.style.maxHeight = startHeight + 'px';

                // Force reflow
                container.offsetHeight;

                // Animate to new height
                container.style.maxHeight = endHeight + 'px';

                // Flip the icon
                icon.classList.toggle('fa-chevron-down', !isExpanding);
                icon.classList.toggle('fa-chevron-up', isExpanding);
            });
        });
    });
});